<template>
    <div class="fields fields_1608103850620">
        <div class="box" :class="{ padding: paddingBottom }">
            <slot></slot>
        </div>
        <button class="btn-confirm" @click="onClick">确认</button>
    </div>
</template>

<script>
export default {
    props: {
        paddingBottom: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        onClick() {
            this.$emit("confirm");
        },
    },
};
</script>

<style>
/** 定义子组件相同的样式---开始 */
.fields_1608103850620 .field {
    display: flex;
    flex-direction: row;
    height: 0.5rem;
    line-height: 0.5rem;
    border-bottom: 1px solid #eeeeee;
}
.fields_1608103850620 .field .label,
.fields_1608103850620 .field .value {
    flex: 1;
    color: #323232;
}
.fields_1608103850620 .field input {
    display: inline-block;
    width: 100%;
    height: 0.3rem;
    line-height: 0.3rem;
    outline: none;
    border: 0;
    font-size: 0.14rem;
    box-sizing: border-box;
}
.fields_1608103850620 .field .value .disabled {
    background-color: #fff;
    color: #bfbfbf;
}
/** 定义子组件相同的样式---结束 */
</style>

<style scoped>
.fields {
    position: relative;
    height: 100vh;
    background-color: #ccc;
    font-size: 0.14rem;
    padding-top: 0.17rem;
    box-sizing: border-box;
}
.box {
    background-color: #fff;
    margin: 0 0.1rem;
    padding: 0.2rem 0.1rem 0;
    border-radius: 0.04rem;
}
.box.padding {
    padding-bottom: 0.2rem;
}
.btn-confirm {
    position: absolute;
    bottom: 0;
    display: block;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    border: 0;
    outline: none;
    font-size: 0.14rem;
    color: #fff;
    background-color: #0682c8;
}
</style>
